const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '实时追踪热点',
    desc: '全天候监测各大平台热搜与艺人动态，暴走黑料系列保持每日更新，重大事件2小时内出专题，确保你不错过任何一条爆款黑料。',
  },
  {
    id: 2,
    icon: 'ri-stack-line',
    title: '系列化内容整理',
    desc: '所有黑料按暴走黑料、黑料社等品牌系列归类，支持按标签、艺人、事件多维度检索，告别碎片化信息，系统化吃瓜更高效。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '多方交叉验证',
    desc: '每条黑料内容标注原始来源，编辑团队对关键信息进行多渠道交叉比对，在速度与准确性之间寻求最佳平衡。',
  },
  {
    id: 4,
    icon: 'ri-device-line',
    title: '全平台流畅体验',
    desc: '响应式设计完美适配PC、平板和手机端，暴走黑料在线观看和黑料社在线观看均享受一致流畅的浏览体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            平台优势
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            为什么选择黑料在线？暴走黑料与黑料社的核心竞争力
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 text-center group hover:border-primary-500/30 transition-all cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl bg-primary-500/10 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-sm font-semibold text-foreground-800">
                {feature.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}